// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"349":"email-editor","552":"chartjs","714":"markdown-editor"}[chunkId] || chunkId) + "-" + {"94":"d8a5b69f2950aa7df5c7","349":"27f757f75de426962596","492":"7a69f9050661faa894a9","552":"bf4db5b64f28f300d9ab","714":"f15b540d9d62347ed886","818":"11b09da0711560b6928e"}[chunkId] + ".chunk.js";
};